// import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useState } from 'react'
import Highcharts from "highcharts/highstock";
import HighchartsReact from 'highcharts-react-official';
import { useMatchBreakpoints } from '@pancakeswap/uikit';
import moment from 'moment';
import { XAxis, YAxis } from 'recharts';

let zoomindex = 4;
export default function Chart() {

    const [labelShow, setlabelShow] = useState(-20);
    const { isMobile } = useMatchBreakpoints();
    useEffect(() => {
        if (isMobile) {
            setlabelShow(0)
            return;
        }
        setlabelShow(-20)
    }, [isMobile])
    Highcharts.setOptions({
        lang: {
            rangeSelectorFrom: 'From',
            rangeSelectorTo: 'To'
        }
    });

    const [chartdata, setChartData] = useState([])

    async function fetchData() {
        let temp = 24 * 30;
        if (zoomindex !== 0)
            temp = 3600 * 24 * 30;
        const start = moment().format('YYYY-MM-DD 00:00:00');
        const end = moment().subtract(temp, 'hours').format('YYYY-MM-DD H:M:S');
        const endDate = Date.now() / 1000;
        let startDate = 0;
        if (zoomindex === 0)
            startDate = endDate - 24 * 30 * 3600;
        const cakePriceCoinGeckoApi = `https://api.coingecko.com/api/v3/coins/drivenx/market_chart/range?vs_currency=usd&from=${startDate}&to=${endDate}`;

        while (true) {
            const res = await fetch(cakePriceCoinGeckoApi);
            const responseData = await res.json();

            if (responseData.prices.length > 0) {
                setChartData(responseData.prices);
                break;
            }
        }

    }

    useEffect(() => {
        fetchData()
    }, [zoomindex]);

    const options = {
        yAxis: [{
            labels: {
                align: 'left',
                format: '${value:.4f}',
                x: 12,
                y: 0,
            },
            crosshair: false,

        }],
        xAxis: [{
            crosshair: true,
            labels: {
                allowOverlap: false
            },

        }],

        tooltip: {
            split: false,
            shared: true,
            x: XAxis,
            y: YAxis,
            formatter: function () {
                var tooltip = '<div style="color:rgb(0, 254, 217);">' + '$' + Number(this.y).toFixed(4) + '</div><br/>';
                var temp = Highcharts.dateFormat('%b %eth %Y, %H:%M', Number(this.x));
                tooltip += `<div style = "color : rgb(0, 254, 217); padding-top : 10px;">${temp}</div>`;
                return tooltip;
            },
            style: { opacity: 1, color: 'white' },
            padding: 10,
            backgroundColor: "#b6b4c9",
        },
        rangeSelector: {
            inputBoxWidth: 85,
            inputBoxHeight: 18,
            inputStyle: {
                color: 'white',
            },
            inputPosition: {
                align: 'right',
                x: 20

            },
            labelStyle: {
                color: 'rgb(177, 179, 203)',
            },
            buttonTheme: { // styles for the buttons
                fill: 'none',
                stroke: 'none',
                'stroke-width': 0,
                r: 8,
                style: {
                    color: 'rgb(177, 179, 203)',
                    fontWeight: 'bold'
                },
                states: {
                    hover: {
                    },
                    select: {
                        fill: 'white',
                        style: {
                            color: 'rgb(0, 254, 217)'
                        }
                    }
                }
            },
            allButtonsEnabled: true,
            selected: zoomindex,
            buttons: [
                {
                    type: 'hour',
                    count: 24,
                    text: '1d',
                    events: {
                        click() {
                            zoomindex = 0;
                            fetchData()
                        }
                    }
                },
                {
                    type: 'day',
                    count: 7,
                    text: '7d',
                    events: {
                        click() {
                            zoomindex = 1;
                            fetchData()
                        }
                    }
                }, {
                    type: 'month',
                    count: 1,
                    text: '1m',
                    events: {
                        click() {
                            zoomindex = 2;
                            fetchData()
                        }
                    }

                }, {
                    type: 'month',
                    count: 3,
                    text: '3m',
                    events: {
                        click() {
                            zoomindex = 3;
                            fetchData()
                        }
                    }
                }, {
                    type: 'all',
                    text: 'All',
                    events: {
                        click() {
                            zoomindex = 4;
                            fetchData()
                        }
                    }
                }],
            buttonPosition: {
                align: 'middle',
                x: labelShow
            },
        },
        scrollbar: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                shadow: false,
            }
        },
        navigator: {
            outlineColor: "#24234e", /*works*/
            xAxis: {
                gridLineColor: "#24234e",
            },
        },
        series: [
            {
                data: chartdata,
                color: '#00FED9',
            },
        ],
        chart: {
            height: 450,
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 100 + '%'
                },
            }]
        }
    };
    return (
        <HighchartsReact
            highcharts={Highcharts}
            constructorType={"stockChart"}
            options={options}
        />
    );
}
